export const THREADS_MAX_DESCRIPTION_CHARS = 500;
